import React from 'react';
import Header from '../../components/Header';
import ContactBody from '../../components/Contact/ContactBody';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page-black-back">
      <Header PageName="contact us" fTitle="contact" sTitle="us" />
      <ContactBody />
    </div>
  );
};

export default Contact;
